import { mapActions, mapGetters, mapState } from 'vuex';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import marketListItemV2 from '@/components/market/v2/market-list-item-v2/market-list-item-v2.vue';
import loaderMixin from '@/mixins/loader';

export default {
  mixins: [
    loaderMixin,
  ],
  props: {
    num: {
      type: Number,
      default: 3,
    },
  },
  components: {
    marketListItem: marketListItemV2,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      activeIndex: 0,
      swiperOptions: {
        slidesPerView: 1,
        direction: 'horizontal',
        spaceBetween: 0,
        onTransitionStart: (swp) => {
          this.activeIndex = swp.activeIndex;
        },
      },
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapState('browse', ['newArrivalMarkets']),
    title() {
      return 'New Arrivals';
    },
    items() {
      return this.newArrivalMarkets;
    },
    isPrevArrowDisabled() {
      return this.activeIndex === 0;
    },
    isNextArrowDisabled() {
      return this.items.length === 0 || this.activeIndex === (this.num - 1);
    },
    prevArrowModifiers() {
      return {
        'most-predicted__header-arrow': true,
        'most-predicted__header-arrow--left': true,
        'most-predicted__header-arrow--disabled': this.isPrevArrowDisabled,
      };
    },
    nextArrowModifiers() {
      return {
        'most-predicted__header-arrow': true,
        'most-predicted__header-arrow--right': true,
        'most-predicted__header-arrow--disabled': this.isNextArrowDisabled,
      };
    },
  },
  methods: {
    ...mapActions('browse', ['getNewArrivalMarkets']),
    prevSlide() {
      if (!this.isPrevArrowDisabled) this.$refs.swiper.swiper.slidePrev();
    },
    nextSlide() {
      if (!this.isNextArrowDisabled) this.$refs.swiper.swiper.slideNext();
    },
  },
  mounted() {
    const payload = {
      limit: this.num,
    };

    this.loaderAdd();

    this.getNewArrivalMarkets(payload)
      .then(() => {
        this.loaderRemove();
        this.isComponentReady = true;
      })
      .catch(() => this.loaderRemove());
  },
};



// WEBPACK FOOTER //
// ./src/components/home/home-old/most-predicted/most-predicted.js